import IconComponent from 'gcs-common/components/Icon/Icon';
import { ICON, ICON_COLOR, ICON_SIZE } from 'gcs-common/constants/IconConstants';
import { cn } from 'gcs-common/design-system/utils/tailwind-merge';
import { TICKET_STATUS_BADGES } from 'gcs-common/slices/tickets/ticketsConstants';

interface TicketStatusProps {
  status: keyof typeof TICKET_STATUS_BADGES;
}

const TicketStatus = (props: TicketStatusProps) => {
  const { status } = props;
  const title = TICKET_STATUS_BADGES[status]?.title || 'Verarbeitung';
  const iconColor = TICKET_STATUS_BADGES[status]?.iconColor || ICON_COLOR.LIGHT_GREY;
  const badgeStyling = 'px-2 py-1 flex-row inline-flex items-center rounded-xl text-xs gap-1.5 w-fit';

  return (
    <span
      className={cn(
        badgeStyling,
        TICKET_STATUS_BADGES[status]?.backgroundColor,
        TICKET_STATUS_BADGES[status]?.foregroundColor,
      )}
    >
      {TICKET_STATUS_BADGES[status]?.iconColor && (
        <IconComponent Icon={ICON.ECLIPSE} size={ICON_SIZE.XXXX_SMALL} tailwindColorClass={iconColor} />
      )}
      {title}
    </span>
  );
};

export default TicketStatus;
